import { DELETE, GET, PATCH, POST } from '../../../common/common.service'
import endpointsComercialDatas from './enpoints'

const ComercialDataTypesService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsComercialDatas.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsComercialDatas.LOAD_BY_ID(id)),
  create: async (body) => POST(endpointsComercialDatas.CREATE, body),
  update: async ({ _id, body }) =>
    PATCH(endpointsComercialDatas.LOAD_BY_ID(_id), body),
  remove: async (id) => DELETE(endpointsComercialDatas.LOAD_BY_ID(id)),
}

export default ComercialDataTypesService
